module.exports = __webpack_public_path__ + "img/lacrosse-stick-ball.aa87dd2c.svg";